<template>
  <div class="">
    <landing />
    <About id="about" />
    <Program id="program" />
    <!-- <Sec3 /> -->
    <Different id="different" />
    <Outline id="outline" />
    <Saying />
    <Certificate />
    <Video />
    <Faq id="faq" />

    <Contact />
  </div>
</template>

<script>
import Faq from '../components/faq/DataScienceFaq.vue'
import Landing from '../components/IsaData/LandingIm.vue'
import Contact from '../components/IsaData/Contactds.vue'
// import Sec3 from '../components/IsaData/Section4thIm.vue'
import Certificate from '../components/IsaData/Certificate.vue'
import Different from '../components/IsaData/Different.vue'
import About from '../components/IsaData/About.vue'
import Program from '../components/IsaData/Program.vue'
import Outline from '../components/IsaData/Outline.vue'
import Video from '../components/IsaData/VideoSection.vue'
import Saying from '../components/IsaData/Saying.vue'
export default {
  components: {
    Landing,
    Contact,
    Saying,
    // Sec3,
    Certificate,
    Different,
    About,
    Program,
    Outline,
    Faq,
    Video,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
